export const HistoricalTechDocTypes = Object.freeze([
  'User Manual',
  'Parts Breakdown',
  'Product Diagram',
  'Other',
]);
